export class PhotoStorage {}
